/* mypuppykit: scroll reveals for tiles and section heads. Content is visible
   without JS; with JS, elements enter once, staggered inside their parent. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var SELECTOR = [
    '.mpk-head',
    '.mpk-tile',
    '.mpk-usp__item',
    '.mpk-faq__item',
    '.mpk-compare__table',
    '.mpk-footer__tile',
  ].join(',');

  function prepare(root) {
    var nodes = root.querySelectorAll(SELECTOR);
    var counters = new Map();
    nodes.forEach(function (el) {
      if (el.classList.contains('mpk-in') || el.classList.contains('mpk-out')) return;
      var parent = el.parentElement;
      var i = counters.get(parent) || 0;
      counters.set(parent, i + 1);
      el.style.setProperty('--mpk-delay', Math.min(i, 6) * 70 + 'ms');
      el.classList.add('mpk-out');
      observer.observe(el);
    });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('mpk-in');
        entry.target.classList.remove('mpk-out');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  document.documentElement.classList.add('mpk-js');
  prepare(document);

  // Sections re-rendered by the theme editor or by Horizon's section rendering
  var mo = new MutationObserver(function (records) {
    records.forEach(function (r) {
      r.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) prepare(n);
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();
